class DotoHomeHeroV2 {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-doto-hero-track]');
    this.slides = Array.from(section.querySelectorAll('[data-doto-hero-slide]'));
    this.dots = Array.from(section.querySelectorAll('[data-doto-hero-dot]'));
    this.prev = section.querySelector('[data-doto-hero-prev]');
    this.next = section.querySelector('[data-doto-hero-next]');
    this.autoplay = section.dataset.autoplay === 'true';
    this.loop = section.dataset.loop === 'true';
    this.delay = (Number.parseInt(section.dataset.autoplaySpeed || '6', 10) || 6) * 1000;
    this.index = 0;
    this.timer = null;
    this.scrollTimer = null;

    if (!this.track || this.slides.length <= 1) return;

    this.onScroll = this.onScroll.bind(this);
    this.onVisibility = this.onVisibility.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);

    this.bind();
    this.updateDots(0);
    this.start();
  }

  bind() {
    this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
    this.next?.addEventListener('click', () => this.goTo(this.index + 1));
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.track.addEventListener('pointerdown', this.onPointerDown, { passive: true });
    this.track.addEventListener('mouseenter', () => this.stop());
    this.track.addEventListener('mouseleave', () => this.start());
    document.addEventListener('visibilitychange', this.onVisibility);

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(Number.parseInt(dot.dataset.dotoHeroDot || '0', 10)));
    });
  }

  onPointerDown() {
    this.stop();
    window.setTimeout(() => this.start(), this.delay * 1.25);
  }

  onVisibility() {
    if (document.hidden) this.stop();
    else this.start();
  }

  onScroll() {
    window.clearTimeout(this.scrollTimer);
    this.scrollTimer = window.setTimeout(() => {
      const width = this.track.clientWidth || 1;
      const nextIndex = Math.round(this.track.scrollLeft / width);
      this.index = Math.max(0, Math.min(nextIndex, this.slides.length - 1));
      this.updateDots(this.index);
    }, 80);
  }

  goTo(index, smooth = true) {
    if (!this.slides.length) return;
    let target = index;

    if (this.loop) {
      target = (target + this.slides.length) % this.slides.length;
    } else {
      target = Math.max(0, Math.min(target, this.slides.length - 1));
    }

    this.index = target;
    this.track.scrollTo({
      left: this.track.clientWidth * target,
      behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
    });
    this.updateDots(target);
    this.start();
  }

  updateDots(index) {
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  start() {
    this.stop();
    if (!this.autoplay || document.hidden) return;
    this.timer = window.setInterval(() => this.goTo(this.index + 1), this.delay);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  destroy() {
    this.stop();
    window.clearTimeout(this.scrollTimer);
    this.track?.removeEventListener('scroll', this.onScroll);
    this.track?.removeEventListener('pointerdown', this.onPointerDown);
    document.removeEventListener('visibilitychange', this.onVisibility);
  }
}

const dotoHeroV2Instances = new Map();

function initDotoHeroV2(section) {
  if (!section || dotoHeroV2Instances.has(section)) return;
  dotoHeroV2Instances.set(section, new DotoHomeHeroV2(section));
}

function destroyDotoHeroV2(section) {
  dotoHeroV2Instances.get(section)?.destroy();
  dotoHeroV2Instances.delete(section);
}

document.querySelectorAll('[data-doto-home-hero-v2]').forEach(initDotoHeroV2);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll?.('[data-doto-home-hero-v2]').forEach(initDotoHeroV2);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll?.('[data-doto-home-hero-v2]').forEach(destroyDotoHeroV2);
});

document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.closest?.('[data-doto-hero-slide]');
  const section = event.target.closest?.('[data-doto-home-hero-v2]');
  if (!slide || !section) return;
  initDotoHeroV2(section);
  const instance = dotoHeroV2Instances.get(section);
  instance?.goTo(Number.parseInt(slide.dataset.index || '0', 10), false);
  instance?.stop();
});
